import React from 'react'

import WalkthroughFlow from '@/components/flows/WalkthroughFlow/WalkthroughFlow'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog'

interface Props {
  onHide: () => void
}

const WalkthroughModal: React.FC<Props> = ({ onHide }) => (
  <Dialog open onHide={onHide}>
    <DialogContent size="xl" showCloseButton={false}>
      <DialogBody>
        <WalkthroughFlow
          variant="component"
          title="How does RQ work?"
          completeButtonText="Close"
          onComplete={onHide}
        />
      </DialogBody>

      <DialogFooter>
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
)

export default WalkthroughModal
